/* SKIMP: tidy colour filter - names next to swatches, colour-family order, UK spelling, rainbow swatch for multicolour */
(function () {
  var ORDER = ['white','beige','yellow','orange','pink','red','purple','blue','navy','green','brown','gray','grey','black','multicolor'];
  var RENAME = {gray:'Grey', multicolor:'Multicolour'};
  var SHOW = 16;
  function tidy() {
    document.querySelectorAll('.collection__filter-tags--swatches').forEach(function (ul) {
      if (ul.dataset.sbTidy || ul.parentElement.closest('.collection__filter-tags--swatches')) return;
      ul.dataset.sbTidy = '1';
      ul.classList.add('sb-swatch-list');
      var items = [].slice.call(ul.querySelectorAll('li.collection__filter-tag--swatch'));
      var actions = ul.querySelector(':scope > .collection__filter-actions');
      items.forEach(function (li) {
        var label = li.querySelector('.swatch__label');
        if (!label) return;
        var raw = (label.getAttribute('data-tooltip') || label.getAttribute('data-swatch') || '').trim();
        var key = raw.toLowerCase();
        var i = ORDER.indexOf(key);
        li.dataset.sbRank = i > -1 ? i : 50;
        if (key === 'multicolor' || key === 'multicolour') {
          label.style.setProperty('background', 'conic-gradient(#f61f1f,#ffe500,#05aa3d,#005bd3,#a54dcf,#f61f1f)', 'important');
        }
        if (!li.querySelector('.sb-swatch-name')) {
          var s = document.createElement('label');
          s.className = 'sb-swatch-name';
          s.setAttribute('for', label.getAttribute('for'));
          s.textContent = RENAME[key] || raw;
          li.appendChild(s);
        }
      });
      items.sort(function (x, y) { return x.dataset.sbRank - y.dataset.sbRank; }).forEach(function (li) { ul.appendChild(li); });
      if (actions) actions.remove();
      var anyChecked = items.some(function (li) { var i = li.querySelector('input'); return i && i.checked; });
      if (items.length > SHOW + 2 && !anyChecked) {
        ul.classList.add('sb-collapsed');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sb-swatch-toggle';
        btn.textContent = 'Show all ' + items.length + ' colours';
        btn.addEventListener('click', function () {
          var c = ul.classList.toggle('sb-collapsed');
          btn.textContent = c ? 'Show all ' + items.length + ' colours' : 'Show fewer colours';
        });
        ul.insertAdjacentElement('afterend', btn);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', tidy);
  var q = false;
  new MutationObserver(function () {
    if (q) return; q = true;
    requestAnimationFrame(function () { q = false; tidy(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();